var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"options":_vm.options,"props":_vm.props},model:{value:(_vm.selectedOptions),callback:function ($$v) {_vm.selectedOptions=$$v},expression:"selectedOptions"}})
}
var staticRenderFns = []

export { render, staticRenderFns }